namespace TabAurous.OMS {
    export interface HSNRow {
        Id?: number;
        Code?: string;
        Name?: string;
        Description?: string;
        RateApplied?: boolean;
        Num1?: number;
        Num2?: number;
        Num3?: number;
        String1?: string;
        String2?: string;
        String3?: string;
        SysDate?: string;
        TaxCode?: string;
    }

    export namespace HSNRow {
        export const idProperty = 'Code';
        export const nameProperty = 'Code';
        export const localTextPrefix = 'OMS.HSN';
        export const lookupKey = 'OMS.HSN';

        export function getLookup(): Q.Lookup<HSNRow> {
            return Q.getLookup<HSNRow>('OMS.HSN');
        }
        export const deletePermission = 'Masters:HSN:Delete';
        export const insertPermission = 'Masters:HSN:Add';
        export const readPermission = '*';
        export const updatePermission = 'Masters:HSN:Edit';

        export declare const enum Fields {
            Id = "Id",
            Code = "Code",
            Name = "Name",
            Description = "Description",
            RateApplied = "RateApplied",
            Num1 = "Num1",
            Num2 = "Num2",
            Num3 = "Num3",
            String1 = "String1",
            String2 = "String2",
            String3 = "String3",
            SysDate = "SysDate",
            TaxCode = "TaxCode"
        }
    }
}
